import { BrowserState, type StoragePort } from "../domain/browserState";
let cached: BrowserState | undefined;
let originStorage: StoragePort | undefined;
export function browserState(): BrowserState {
  let local: StoragePort | undefined;
  let session: StoragePort | undefined;
  const unavailable: string[] = [];
  try { local = window.localStorage; } catch { unavailable.push("inaccessible_local_storage"); }
  try { session = window.sessionStorage; } catch { unavailable.push("inaccessible_session_storage"); }
  if (!cached || originStorage !== local) { originStorage = local; cached = new BrowserState(local, session, () => Date.now(), unavailable); }
  return cached;
}
export function loadJson<T>(key: string, fallback: T): T { return browserState().readJson(key, fallback); }
export function saveJson(key: string, value: unknown): boolean { return browserState().writeJson(key, value); }
export function loadPreference(key: string): string | null { return browserState().readPreference(key); }
export function savePreference(key: string, value: string): boolean { return browserState().writePreference(key, value); }
